import { useEffect, useState } from "react";
import { getShop } from "./requests";
import { useParams } from "react-router";

export const useGetShop = () => {
  const params = useParams();
  const name = params.name;
  const [isLoading, setIsLoading] = useState(false);
  const [shop, setShop] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const response = await getShop({ name });
        setShop(response);
      } catch (error) {
        setShop(null);
      } finally {
        setIsLoading(false);
      }
    };
    void getData();
  }, [name]);

  return {
    isLoading,
    shop
  };
};
